// extracted by mini-css-extract-plugin
module.exports = {"primaryButton":"dashboard-primaryButton-3yX4bP","gridWidget":"dashboard-gridWidget-1ePtr7","pivotChartWidget":"dashboard-pivotChartWidget-2UTC3v"};